import React from 'react';
interface SiteFooterProps {
  /** Route of the page rendering the footer, so its own link can be marked current. */
  currentPath?: string;
}
const links = [{
  href: '/get-the-app',
  label: 'Download the App'
}, {
  href: '/practitioners',
  label: 'Practitioners'
}, {
  href: '/investors',
  label: 'Investors'
}, {
  href: '/privacy-policy',
  label: 'Privacy Policy'
}, {
  href: '/terms-of-service',
  label: 'Terms of Service'
}];
export function SiteFooter({
  currentPath
}: SiteFooterProps) {
  return <footer className="bg-charcoal text-ivory/50 border-t border-white/10" data-id="element-548" data-mp="6q99i93dcl0i">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-10 flex flex-col md:flex-row md:items-center md:justify-between gap-6 text-sm" data-id="element-549" data-mp="3p25q7o8zrl1v">
        <p data-id="element-550" data-mp="llp4qhfoqmyh">© {new Date().getFullYear()} Fem Entity. All rights reserved.</p>
        <nav aria-label="Footer" data-id="element-551" data-mp="ljm83ek11vks">
          <ul className="flex flex-wrap items-center gap-x-8 gap-y-3" data-id="element-552" data-mp="qcxi1ok4ysgx">
            {links.map(link => {
            const isCurrent = link.href === currentPath;
            return <li key={link.href} data-id="element-553" data-mp="1fz6pon4xdt4a">
                  <a href={link.href} aria-current={isCurrent ? 'page' : undefined} className={`transition-colors duration-200 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-300 focus-visible:ring-offset-2 focus-visible:ring-offset-charcoal rounded ${isCurrent ? 'text-ivory' : 'hover:text-ivory'}`} data-id="element-554" data-mp="1g07ysm2ds5jd">
                    {link.label}
                  </a>
                </li>;
          })}
          </ul>
        </nav>
      </div>
    </footer>;
}